import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

const adminToken = secureStorage.getItem("adminToken");

const API_URL = "/admin/local/country";

const headers = {
  Authorization: `Bearer ${adminToken}`,
  "Content-Type": "application/json",
};

const initialFormData = {
  id: null,
  countryName: "",
  isDefault: 0,
  status: 1,
};

// GET ALL COUNTRIES
export const viewCountry = (setCountryData, setLoading) => {
  if (setLoading) setLoading(true);

  axiosInstance
    .get(API_URL, { headers })
    .then((res) => {
      setCountryData(res.data.data || []);
    })
    .catch((err) => {
      console.error("Country fetch error:", err);
      toast.error(err.response?.data?.message || "Country data not found");
    })
    .finally(() => {
      if (setLoading) setLoading(false);
    });
};

// ADD COUNTRY
export const addCountry = (
  FormData,
  setFormData,
  setCountryData,
  setLoading,
) => {
  axiosInstance
    .post(API_URL, FormData, { headers })
    .then((res) => {
      if (res.data.message === "Country added successfully") {
        toast.success("Country added");
        setFormData({ ...initialFormData });

        viewCountry(setCountryData, setLoading);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.error("Country add error:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    });
};

// UPDATE COUNTRY
export const updateCountry = (
  FormData,
  setFormData,
  setCountryData,
  setLoading,
) => {
  axiosInstance
    .put(API_URL, FormData, { headers })
    .then((res) => {
      if (res.data.message === "Country updated successfully") {
        toast.success("Country updated");
        setFormData({ ...initialFormData });

        viewCountry(setCountryData, setLoading);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.error("Country update error:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    });
};

// DELETE COUNTRY
export const deleteCountry = (id, setCountryData, setLoading) => {
  axiosInstance
    .delete(API_URL, {
      headers,
      data: { id },
    })
    .then((res) => {
      if (res.data.message === "Country deleted successfully") {
        toast.success("Country deleted");

        viewCountry(setCountryData, setLoading);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.error("Country delete error:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    });
};
